export const MAX_PAYOUT_EXPORT_SIZE = 100;

export const normalizeIban = (value) => String(value || "").replace(/\s+/g, "").toUpperCase();

export const isValidIban = (value) => {
    const iban = normalizeIban(value);
    if (!/^[A-Z]{2}\d{2}[A-Z0-9]{11,30}$/.test(iban)) return false;

    const rearranged = `${iban.slice(4)}${iban.slice(0, 4)}`;
    let remainder = 0;
    for (const character of rearranged) {
        const numericValue = /[A-Z]/.test(character)
            ? String(character.charCodeAt(0) - 55)
            : character;
        for (const digit of numericValue) {
            remainder = ((remainder * 10) + Number(digit)) % 97;
        }
    }
    return remainder === 1;
};

export const resolveRecipientName = (employee = {}) => {
    const fullName = [employee.firstName, employee.lastName]
        .map((part) => String(part || "").trim())
        .filter(Boolean)
        .join(" ");

    return fullName
        || String(employee.displayName || "").trim()
        || String(employee.name || "").trim();
};

export const getTimestampMillis = (value) => {
    if (!value) return Number.NEGATIVE_INFINITY;
    if (typeof value.toMillis === "function") return value.toMillis();
    if (typeof value.toDate === "function") return value.toDate().getTime();
    if (typeof value.seconds === "number") return value.seconds * 1000;

    const date = value instanceof Date ? value : new Date(value);
    return Number.isNaN(date.getTime()) ? Number.NEGATIVE_INFINITY : date.getTime();
};

export const getPayoutCandidateIssue = ({recipientName, iban, amount}) => {
    if (!String(recipientName || "").trim()) return "Missing recipient name";
    if (!isValidIban(iban)) return "Missing or invalid recipient IBAN";

    const numericAmount = Number(amount);
    const cents = Math.round(numericAmount * 100);
    if (!Number.isFinite(numericAmount) || numericAmount <= 0) return "Amount must be greater than zero";
    if (Math.abs(numericAmount - (cents / 100)) > 0.000001) return "Amount must have no more than two decimals";
    return "";
};

export const sortPayoutCandidatesNewestFirst = (candidates) => [...candidates].sort((left, right) => {
    const leftTimestamp = getTimestampMillis(left.createdAt);
    const rightTimestamp = getTimestampMillis(right.createdAt);
    if (leftTimestamp === Number.NEGATIVE_INFINITY && rightTimestamp !== Number.NEGATIVE_INFINITY) return 1;
    if (rightTimestamp === Number.NEGATIVE_INFINITY && leftTimestamp !== Number.NEGATIVE_INFINITY) return -1;
    if (leftTimestamp !== rightTimestamp) return rightTimestamp - leftTimestamp;
    return String(right.id || "").localeCompare(String(left.id || ""));
});
